import { FieldError } from 'lms/types/bulkInscription';
import { InscriptionErrorCodes } from 'lms/types/bulkInscription';

export const usersMock = [
  {
    avatar_url: 'https://i.pravatar.cc/150?img=1',
    role_name: 'Administrator',
    role_id: '1',
    ou_name: 'IT Department',
    ou_id: '101',
    first_name: 'John',
    last_name: 'Doe',
    id: 'user1',
  },
  {
    avatar_url: 'https://i.pravatar.cc/150?img=2',
    role_name: 'Manager',
    role_id: '2',
    ou_name: 'Sales Department',
    ou_id: '102',
    first_name: 'Jane',
    last_name: 'Smith',
    id: 'user2',
  },
  {
    avatar_url: 'https://i.pravatar.cc/150?img=3',
    role_name: 'Developer',
    role_id: '3',
    ou_name: 'Development Team',
    ou_id: '103',
    first_name: 'Alice',
    last_name: 'Johnson',
    id: 'user3',
  },
  {
    avatar_url: 'https://i.pravatar.cc/150?img=4',
    role_name: 'Support',
    role_id: '4',
    ou_name: 'Customer Service',
    ou_id: '104',
    first_name: 'Bob',
    last_name: 'Williams',
    id: 'user4',
  },
  {
    avatar_url: 'https://i.pravatar.cc/150?img=5',
    role_name: 'HR',
    role_id: '5',
    ou_name: 'Human Resources',
    ou_id: '105',
    first_name: 'Carol',
    last_name: 'Brown',
    id: 'user5',
  },
  {
    avatar_url: 'https://i.pravatar.cc/150?img=6',
    role_name: 'Finance',
    role_id: '6',
    ou_name: 'Finance Department',
    ou_id: '106',
    first_name: 'David',
    last_name: 'Jones',
    id: 'user6',
  },
  {
    avatar_url: 'https://i.pravatar.cc/150?img=7',
    role_name: 'Marketing',
    role_id: '7',
    ou_name: 'Marketing Team',
    ou_id: '107',
    first_name: 'Eva',
    last_name: 'Garcia',
    id: 'user7',
  },
  {
    avatar_url: 'https://i.pravatar.cc/150?img=8',
    role_name: 'Product Manager',
    role_id: '8',
    ou_name: 'Product Team',
    ou_id: '108',
    first_name: 'Frank',
    last_name: 'Martinez',
    id: 'user8',
  },
  {
    avatar_url: 'https://i.pravatar.cc/150?img=9',
    role_name: 'Analyst',
    role_id: '9',
    ou_name: 'Analytics Team',
    ou_id: '109',
    first_name: 'Gina',
    last_name: 'Wilson',
    id: 'user9',
  },
  {
    avatar_url: 'https://i.pravatar.cc/150?img=10',
    role_name: 'Designer',
    role_id: '10',
    ou_name: 'Design Team',
    ou_id: '110',
    first_name: 'Henry',
    last_name: 'Anderson',
    id: 'user10',
  },
];

export const fieldErrorsMock: FieldError[] = [
  {
    column: 'Email',
    row: 1,
    errorCode: InscriptionErrorCodes.userNotFound,
    data: 'brayan.santos@lapzo.com',
  },
  {
    column: 'Email',
    row: 4,
    errorCode: InscriptionErrorCodes.userNotFound,
    data: 'michelle.gutierrez@lapzo.com',
  },
  {
    column: 'Email',
    row: 5,
    errorCode: InscriptionErrorCodes.userNotFound,
    data: 'sandra.perez@lapzo.com',
  },
  {
    column: 'Email',
    row: 9,
    errorCode: InscriptionErrorCodes.userNotFound,
    data: 'andrea.reyes@lapzo.io',
  },
  {
    column: 'Email',
    row: 1,
    errorCode: InscriptionErrorCodes.userNotFound,
    data: 'brayan.santos@lapzo.com',
  },
  {
    column: 'Email',
    row: 4,
    errorCode: InscriptionErrorCodes.userNotFound,
    data: 'michelle.gutierrez@lapzo.com',
  },
  {
    column: 'Email',
    row: 5,
    errorCode: InscriptionErrorCodes.userNotFound,
    data: 'sandra.perez@lapzo.com',
  },
  {
    column: 'Email',
    row: 9,
    errorCode: InscriptionErrorCodes.userNotFound,
    data: 'andrea.reyes@lapzo.io',
  },
  {
    column: 'Email',
    row: 1,
    errorCode: InscriptionErrorCodes.userNotFound,
    data: 'brayan.santos@lapzo.com',
  },
  {
    column: 'Email',
    row: 4,
    errorCode: InscriptionErrorCodes.userNotFound,
    data: 'michelle.gutierrez@lapzo.com',
  },
  {
    column: 'Email',
    row: 5,
    errorCode: InscriptionErrorCodes.userNotFound,
    data: 'sandra.perez@lapzo.com',
  },
  {
    column: 'Email',
    row: 9,
    errorCode: InscriptionErrorCodes.userNotFound,
    data: 'andrea.reyes@lapzo.io',
  },
];
